import { FC, SVGProps } from 'react';

const DeveloperTerminalIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#fff',
  size = 20,
  ...props
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M11.4878 2.50002C11.9532 2.50002 12.3983 2.68975 12.7202 3.02542L15.8799 6.3165C16.1848 6.63434 16.3559 7.05839 16.3559 7.49947V14.3037C16.368 16.0162 15.0197 17.4302 13.3081 17.5C13.3081 17.5 6.72833 17.5 6.70319 17.4992C4.97617 17.4611 3.60671 16.0308 3.64482 14.3037V5.54786C3.68536 3.8484 5.07833 2.49353 6.77859 2.50002H11.4878Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.8906 2.55212V4.96266C11.8898 6.13915 12.8425 7.09347 14.019 7.09672H16.3014"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8025 10.1986L12.5838 11.9799L10.7749 13.788"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.8575 8.52222L7.07617 10.3036L8.88508 12.1116"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DeveloperTerminalIcon;
